module.exports = "/_next/static/images/ritesh-850ac0ed14a71a9c0807347119e4deb1.png";